"use client";

import { Core } from "@faire/design-tokens";
import { useDetectScroll } from "@faire/web/ui/hooks/useDetectScroll";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";

import HeaderSearch from "@faire/retailer/components/Header/HeaderSearch";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { useSettingNavSearchUX } from "@faire/retailer/settings/useSettingNavSearchUX";
import { useTopOfPageContentStore } from "@faire/retailer/stores/ui/TopOfPageContentStore";

const SEARCH_HEIGHT = 64;

interface IProps {
  isSeparateFromHeader?: boolean;
}

export const MaybeMobileSearchBarXP: React.FC<IProps> = ({
  isSeparateFromHeader,
}) => {
  const { isTabletAndAbove } = useViewport();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { scrollDirection } = useDetectScroll("y", 5);
  const { isTreatment: isNavSearchUX, isStickyVariant } =
    useSettingNavSearchUX();
  const { headerHeight } = useTopOfPageContentStore(["headerHeight"]);

  const topPosition = useMemo(() => {
    return scrollDirection === "up" || isStickyVariant
      ? headerHeight - 1
      : headerHeight - SEARCH_HEIGHT - 1;
  }, [scrollDirection, isStickyVariant, headerHeight]);

  if (
    isTabletAndAbove ||
    (!isLoggedInRetailer && !isNavSearchUX) ||
    (isLoggedInRetailer && isSeparateFromHeader)
  ) {
    return null;
  }

  if (isLoggedInRetailer) {
    return (
      <HeaderSearch
        inputId="mobile-top-search-xp"
        inputDataTestId="mobileSearchBarInput"
      />
    );
  }

  return (
    <Wrapper $topPosition={topPosition}>
      <HeaderSearch
        inputId="mobile-top-search-xp"
        inputDataTestId="mobileSearchBarInput"
      />
    </Wrapper>
  );
};

const Wrapper = styled.div<{
  $topPosition: number;
}>`
  width: 100%;
  transition: top 0.3s ease-in-out;
  top: ${(props) => props.$topPosition}px;
  position: sticky;
  z-index: 1;
  border-bottom: 1px solid ${Core.border.muted};
`;
